<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2021-05-17 12:01:52
 * @FilePath: \EmAtlas\src\components\analysis\GenomeBrowser.vue
-->
<template>
    <el-container class="baimo-scrollbar bm">
        <el-aside :style="{ width: subpannel_wight + 'px' }" class="bm-aside">
            <div style="height: 30px; color: #2F363D; background: #F6F8FA;border-top: 1px solid #E1E4E8;border-bottom: 1px solid #E1E4E8">
                <p style="padding: 5px 0px 0px 5px; font-weight: 900">Settings</p>
            </div>
            <div style="padding: 10px;">
                <protein-selector v-on:proteinAccession="getProteinAccession"></protein-selector>
                <raac-selector></raac-selector>
                <three-selector></three-selector>
            </div>
        </el-aside>
        <el-main style="padding: 0px;">
            <structure-view :height="structrueHeight + 'px'" :width="yhandleWidth"></structure-view>
            <BaimocYHandle @widthChange="widthChange"/>
            <sequence-view v-if="seq_view === 'single'" :height="totalHeight - structrueHeight - 120 + 'px'" :width="yhandleWidth" :params="params"
                           v-on:selectedRange="getSelectedRange"></sequence-view>
            <multi-sequence-view v-if="seq_view === 'multi'" :height="totalHeight - structrueHeight - 120 + 'px'" :width="yhandleWidth"
                                v-on:selectedRange="getSelectedRange"></multi-sequence-view>
            <align-sequence-view v-if="seq_view === 'align'" :height="totalHeight - structrueHeight - 120 + 'px'" :width="yhandleWidth"
                                 v-on:selectedRange="getSelectedRange"></align-sequence-view>
        </el-main>
    </el-container>
</template>

<script>
    import StructureView from "./StructureView"
    import SequenceView from "./SequenceView"
    import MultiSequenceView from "./MultiSequenceView"
    import AlignSequenceView from "./sequence/AlignSequenceView"
    import ProteinSelector from "./selector/ProteinSelector"
    import RaacSelector from "./selector/RaacSelector"
    import ThreeSelector from "./selector/ThreeSelector"
    import BaimocYHandle from "./BaimocYHandle"
    import axios from "axios";


    import global_ from "./units/Global";

    export default {
        name: "ExpBrowser",
        data() {
            return {
                website: global_.website,
                structrueHeight: window.innerHeight - 275,
                totalHeight: window.innerHeight,
                winHeight: window.innerHeight - 52 + "px",
                winWidth: window.innerWidth - 50 + "px",
                subpannel_wight: 360 + "px",
                yhandleWidth: window.innerWidth - 360 + "px",
                loading: true,
                seq_view: 'single',
                selectedRange: null,
                proteinAccession: '',
                accession: 'Q01860',
                params: {
                    source: {
                        pdb: "api/source/pdb/AF-A0A0A0MPE6-F1-model_v1.pdb",
                        sequence: ""
                    },
                    raac_scheme: {
                        name: "type1",
                        raac: "LVIMCAGSTPFYW-EDNQKRH",
                        color: "#786fa6,#f5cd79"
                    },
                    view_scheme: {
                        name: "cartoon"
                    },

                },
            };
        },
        watch: {
            proteinAccession(accession) {
                this.getProteinInfo(accession);
            }
        },
        components: {
            SequenceView,
            MultiSequenceView,
            StructureView,
            BaimocYHandle,
            AlignSequenceView,
            RaacSelector,
            ProteinSelector,
            ThreeSelector
        },
        mounted() {
            this.getProteinInfo(this.accession);
            // console.log(this.totalHeight, window.innerHeight - 275, this.totalHeight - this.structrueHeight)
        },
        methods: {
            getProteinAccession (val){
                this.proteinAccession = val;
                // console.log(val);
            },
            getSelectedRange(val) {
                this.selectedRange = val;
                // console.log(val)
            },
            getProteinInfo(accession) {
                let url = `${this.website}/api/protein_info/${accession}/`;
                // console.log(url);
                axios.get(url).then((res) => {
                    let info = res.data.results[0];
                    this.protein_sequence = info['sequence'];
                    "api/source/pdb/AF-A0A0A0MPE6-F1-model_v1.pdb"
                    this.protein_pdb = info['pdb_url'].replace(/https:\/\/alphafold.ebi.ac.uk\/files/,global_.source);
                    this.params['source']['pdb'] = this.protein_pdb;
                    this.params['source']['sequence'] = this.protein_sequence;
                    this.$store.commit('naturalSeqMutation', this.protein_sequence);
                    // console.log(this.params)
                });
            },
            widthChange(movement) {
                // let seqHeight = window.innerHeight - 275;
                this.structrueHeight -= movement;
                // if (this.structrueHeight < 260) {
                //     this.structrueHeight = 260;
                // }
                // if (this.structrueHeight > seqHeight) {
                //     this.structrueHeight = seqHeight;
                // }
            },

        },
    };

</script>

<style scoped>



</style>
